import { getAPI } from '@/store/api';
import { Action } from '@/store/api/actions';
import { LayerInterface, LayerGroupInterface } from '@/store/models/map';
import { GeomBlock } from '@/store/models/block';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WfsFeatureProperties = Record<string, any>;

export interface WfsFeatureInfo {
  type?: string;
  features: Array<{
    type?: string;
    geometry?: { type: string; coordinates: number[] | number[][] };
    properties: WfsFeatureProperties;
  }>;
}

export default new (class MapAPI {
  public async proxyView(url: string): Promise<WfsFeatureInfo> {
    url = url.replaceAll('/api/proxy/', '');
    return await getAPI<WfsFeatureInfo>(Action.ProxyView, url);
  }
  public async getLayers(query = ''): Promise<LayerInterface[]> {
    return await getAPI<LayerInterface[]>(Action.Layers, query);
  }
  public async getGroupedLayers(
    query = ''
  ): Promise<(LayerInterface | LayerGroupInterface)[]> {
    return await getAPI<(LayerInterface | LayerGroupInterface)[]>(
      Action.GroupedLayers,
      query
    );
  }
  public async getBlockFeature(
    farm: number,
    latitude: number,
    longitude: number
  ): Promise<GeomBlock> {
    const url = Action.BlockFeatureInfo.replace('<farmId>', `${farm}`)
      .replace('<longitude>', `${longitude}`)
      .replace('<latitude>', `${latitude}`);
    return await getAPI<GeomBlock>(url);
  }
  public async getGeoserverConfig(): Promise<{ baseUrl: string }> {
    return await getAPI<{ baseUrl: string }>(Action.GeoserverConfig);
  }
})();
